function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './FeaturedBanner.css';
import React, { useMemo } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../../utils';
import { Link, Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import RouterLink from '../../atoms/RouterLink';
import Video from '../../atoms/Video';
import LazyPicture from '../../atoms/LazyPicture';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { convertToAnalyticObject } from '../../../utils/analytics';
const FeaturedBanner = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const isReverse = get(params, 'rightImage') === '1' || false;
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const isMobile = useMemo(() => {
    return !actualSSR && canUseDOM && window.matchMedia(`(max-width: 991px)`).matches;
  }, [actualSSR]);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('BannerLarge component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BannerLarge component is empty: please provide data source]");
    }
    return null;
  }
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const title = get(fields, 'data.item.title.jss.value');
  const itemName = get(fields, 'data.item.name');
  const src = get(fields, 'data.item.image.jss.value.src');
  const alt = get(fields, 'data.item.image.jss.value.alt');
  const hasVideo = Boolean(get(fields, 'data.item.video.jss.value.href'));
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value', '');
  const name = get(fields, 'data.item.ctaAnalytics.jss.value', ctaLabel);
  const englishTitleForAnalytics = get(fields, 'data.item.titleForAnalytics.jss.value', 'Value not passed');
  const ctaLabelField = get(fields, 'data.item.ctaLabel.jss');
  const ctaLinkHref = get(fields, 'data.item.ctaLink.jss.value.href', '');
  const ctaLinkType = get(fields, 'data.item.ctaLink.jss.value.linktype', '');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', '');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const styleThemeHexColor = BackgroundColorHex ? {
    '--banner-large-background-color': BackgroundColorHex,
    '--banner-large-background-active-color': ActiveColorHex,
    '--banner-large-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex)
  } : {
    '--banner-large-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--banner-large-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--banner-large-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const renderLink = () => {
    if (pageEditing) return /*#__PURE__*/React.createElement("button", {
      "data-testid": "banner-large-editing-cta-link",
      className: "btn btn-secondary banner-btn"
    }, /*#__PURE__*/React.createElement(Link, {
      field: get(fields, 'data.item.ctaLink.jss')
    }));
    if (!ctaLabel || !ctaLinkHref) return null;
    return /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn btn-secondary banner-btn",
      href: ctaLinkHref,
      ariaLabel: `${title} - ${ctaLabel}`,
      linktype: ctaLinkType,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['buttonClickAnalytics'], params), name);
      }
    }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaLeftIcon
      },
      className: "ctaLeftIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Text, {
      field: ctaLabelField
    }), ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaRightIcon
      },
      className: "ctaRightIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null));
  };
  return src && (hasTitle || hasDescription || renderLink()) ? /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite,
    isVideo: hasVideo
  }, /*#__PURE__*/React.createElement("div", {
    className: `${!isDetSite ? 'row' : ''} banner banner--large ${isDetSite && hasVideo ? 'banner--video' : ''}`,
    "data-cy": "banner-large",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: `col-xs-12 col-md-12 col-lg-6 banner__col p-0`
  }, src && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.2,
    delay: 300,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__media video--poster-show",
    "data-cy": "banner-large-media",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "banner__image"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 991px)",
    srcSet: src
  }), /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  })), /*#__PURE__*/React.createElement("div", {
    className: "banner-video-container"
  }, hasVideo && /*#__PURE__*/React.createElement(Video, _extends({
    className: "banner__image banner__videos media-video",
    videoSrc: fields.data.item.video.jss.value.href,
    videoType: fields.data.item.video.jss.value.linktype
  }, isDetSite ? {
    buttonCenterAlignment: true
  } : {
    buttonBottomLeftAlignment: true
  }, {
    loop: true,
    click: e => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params), [e, itemName]),
    isDetSite: isDetSite,
    controls: false
  })))))), (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: `col-xs-12 col-md-12 col-lg-6 banner__col-content p-0`
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.2,
    delay: 400
  }, /*#__PURE__*/React.createElement("div", {
    className: `banner__card theme-contrast`
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    delay: 700,
    animateOnce: true,
    duration: 1,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__text"
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "banner__header",
    style: {
      marginBottom: `${hasDescription ? "" : `${isMobile ? "8px" : "16px"}`}`
    },
    "data-cy": "banner-large-title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "",
    href: ctaLinkHref,
    title: `${title} - ${ctaLabel}`,
    linktype: ctaLinkType,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), englishTitleForAnalytics);
    }
  }, /*#__PURE__*/React.createElement(Text, {
    className: isDetSite ? 'h2' : 'h3',
    tag: isDetSite ? 'h2' : 'h3',
    field: fields.data.item.title.jss
  }))), hasDescription && /*#__PURE__*/React.createElement("div", {
    className: "banner__body",
    "data-cy": "banner-large-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-large"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: fields.data.item.description.jss
  }))), /*#__PURE__*/React.createElement("div", {
    className: "banner__footer",
    "data-cy": "banner-large-cta"
  }, renderLink())))))))) : null;
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isDetSite,
    isVideo
  } = _ref2;
  const commonStyles = isDetSite ? "cgxgpsw" : "cmdphq8";
  const ltrStyles = isDetSite ? "lyg6ijv" : "l52g984";
  const rtlStyles = isDetSite ? "rnx5e" : "rtjnr7b";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${isDetSite ? 'banner--det' : ''} ${isVideo ? 'banner-video-wrap' : ''}`
  }, children);
};
export default FeaturedBanner;